import { ReactNode } from "react";
import { cn } from "../../utils/class-names";
import { getProtocol, ProtocolKey } from "@silo/types";
import { match } from "ts-pattern";
import {
  ArbitrumIcon,
  BaseIcon,
  EthereumIcon,
  LlamaIcon,
  OptimismIcon,
} from "../../icons";

interface ProtocolDisplayProps {
  className?: string;
  protocolKey: ProtocolKey;
}

export function ProtocolDisplay({
  className,
  protocolKey,
}: ProtocolDisplayProps): JSX.Element {
  return (
    <Root className={className}>
      <Icon protocolKey={protocolKey} />

      <Label protocolKey={protocolKey} />
    </Root>
  );
}

ProtocolDisplay.Root = Root;
ProtocolDisplay.Icon = Icon;
ProtocolDisplay.Label = Label;

interface RootProps {
  className?: string;
  children?: ReactNode;
}

function Root({ className, children }: RootProps): JSX.Element {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>{children}</div>
  );
}

interface IconProps {
  protocolKey: ProtocolKey;
}

function Icon({ protocolKey }: IconProps): JSX.Element {
  return match(protocolKey)
    .with("anvil", () => <EthereumIcon />)
    .with("arbitrum", () => <ArbitrumIcon />)
    .with("base", () => <BaseIcon />)
    .with("lrtbase", () => <BaseIcon />)
    .with("local", () => <EthereumIcon />)
    .with("mainnetGrand", () => <EthereumIcon />)
    .with("mainnetLegacy", () => <EthereumIcon />)
    .with("mainnetLlama", () => (
      <div className="flex items-center gap-1">
        <EthereumIcon />
        <LlamaIcon />
      </div>
    ))
    .with("optimism", () => <OptimismIcon />)
    .exhaustive();
}

interface LabelProps {
  className?: string;
  protocolKey: ProtocolKey;
}

function Label({ className, protocolKey }: LabelProps): JSX.Element {
  const protocol = getProtocol(protocolKey);

  return <div className={cn("", className)}>{protocol.label}</div>;
}
